//import { useAppContext } from '../../context/AppContext.jsx';
import "./style.css";
import api from "../../services/api.js";
import Sidebar from "../../componente/sidebar/index.jsx";
import React, { useEffect, useState } from "react";
import { useAppContext } from "../context/AppContext.jsx";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";

Modal.setAppElement("#root");

function Principal() {
  const { codempresa, setLicenca, accessKey, codassinante } = useAppContext(); // Acessa os dados do contexto   
  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showform, setshowform] = useState(false);
  const [novo, setnovo] = useState(false);

  //parametros
  const [CodParametro, setCodParametro] = useState(0);
  const [UltNumPedido, setUltNumPedido] = useState(0);
  const [UltNumNota, setUltNumNota] = useState(0);
  const [UltNumMDFe, setUltNumMDFe] = useState(0);
  const [codcontavenda, setCodContaVenda] = useState(0);
  const [codcontapedidocompra, setCodContaPedidoCompra] = useState(0);
  const [codmoedapedidocompra, setCodMoedaPedidoCompra] = useState(0);
  const [codcaixapedidocompra, setCodCaixaPedidoCompra] = useState(0);
  const [listaCategoria, setListaCategoria] = useState([]);
  const [listaCategoriaPedidoCompra, setListaCategoriaPedidoCompra] = useState([]);
  const [listaMoedaPedidoCompra, setListaMoedaPedidoCompra] = useState([]);
  const [listaCaixaPedidoCompra, setListaCaixaPedidoCompra] = useState([]);

  //configuracaonf
  const [codConfiguracao, setCodConfiguracao] = useState(0);
  // certificado
  const [sSLLib, setSSLLib] = useState(0);
  const [cryptLib, setCryptLib] = useState(0);
  const [httpLib, setHttpLib] = useState(0);
  const [xmlSignLib, setXmlSignLib] = useState(0);
  const [senha, setSenha] = useState('');
  const [arquivoCertificado, setArquivoCertificado] = useState(null);
  //geral
  const [atualizarXML, setAtualizarXML] = useState('');
  const [exibirErroSchema, setExibirErroSchema] = useState('');
  const [formatoAlerta, setFormatoAlerta] = useState('');
  const [formaEmissao, setFormaEmissao] = useState(0);
  const [modeloDF, setModeloDF] = useState(0);
  const [versaoDF, setVersaoDF] = useState(0);
  const [idToken, setIdToken] = useState('');
  const [token, setToken] = useState('');
  const [retirarAcentos, setRetirarAcentos] = useState('');
  const [salvar, setSalvar] = useState('');
  const [pathSalvar, setPathSalvar] = useState('');
  const [pathSchemas, setPathSchemas] = useState('');
  //webservice
  const [uf, setUF] = useState('');
  const [ambiente, setAmbiente] = useState(0);
  const [visualizar, setVisualizar] = useState('');
  const [salvarSOAP, setSalvarSOAP] = useState('');
  const [ajustarAut, setAjustarAut] = useState('');
  const [aguardar, setAguardar] = useState('');
  const [tentativas, setTentativas] = useState('');
  const [intervalo, setIntervalo] = useState('');
  const [timeOut, setTimeOut] = useState(0);
  const [sslType, setSSLType] = useState(0);
  const [proxyHost, setProxyHost] = useState('');
  const [proxyPorta, setProxyPorta] = useState('');
  const [proxyUser, setProxyUser] = useState('');
  const [proxySenha, setProxySenha] = useState('');
  //danfe
  const [tipoDANFE, setTipoDANFE] = useState(0);
  const [logoMarca, setLogoMarca] = useState('');
  const [tipoDANFCE, setTipoDANFCE] = useState(0);
  const [modeloPosPrinter, setModeloPosPrinter] = useState(0);
  const [portaPosPrinter, setPortaPosPrinter] = useState('');
  const [paginaDeCodigo, setPaginaDeCodigo] = useState(0);
  const [paramsString, setParamsString] = useState('');
  const [colunas, setColunas] = useState(0);
  const [espacoLinhas, setEspacoLinhas] = useState(0);
  const [linhasEntreCupons, setLinhasEntreCupons] = useState(0);

  function VerificaLicenca() {
    if (codempresa > 0) {
      api.get("v1/licenca", {
        params: {
          codempresa
        }
      }).then((response) => {

        if (response.data.dia > 3) {
          setLicenca(false);
          alert("Licença venceu, entre em contato com o suporte!")
          navigate("/");
        } else {
          setLicenca(true);
        }
      });
    }
  }
  useEffect(
    function () {
      VerificaLicenca();
    },
    [codempresa]
  );

  async function Salvar() {
    try {
      setLoading(true);
      setError(null);

      if (codempresa === 0) {
                alert('Selecione a filial antes!');
                return; // <-- impede que continue para o POST
            }

      await api.post("v1/parametro", {
        codparametro: CodParametro,
        ultnumpedido: UltNumPedido,
        ultnumnota: UltNumNota,
        ultnummdfe: UltNumMDFe,
        codcontavenda,
        codcontapedidocompra,
        codmoedapedidocompra,
        codcaixapedidocompra,

        codconfiguracao: codConfiguracao,
        //certificado
        ssllib: sSLLib,
        cryptlib: cryptLib,
        httplib: httpLib,
        xmlsignlib: xmlSignLib,
        senha,
        arquivocertificado: arquivoCertificado,
        //geral
        atualizarxml: atualizarXML,
        exibirerroschema: exibirErroSchema,
        formatoalerta: formatoAlerta,
        formaemissao: formaEmissao,
        modelodf: modeloDF,
        versaodf: versaoDF,
        idtoken: idToken,
        token,
        retiraracentos: retirarAcentos,
        salvar,
        pathsalvar: pathSalvar,
        pathschemas: pathSchemas,
        //webservice
        uf,
        ambiente,
        visualizar,
        salvarsoap: salvarSOAP,
        ajustaraut: ajustarAut,
        aguardar,
        tentativas,
        intervalo,
        timeout: timeOut,
        ssltype: sslType,
        proxyhost: proxyHost,
        proxyporta: proxyPorta,
        proxyuser: proxyUser,
        proxysenha: proxySenha,
        //danfe              
        tipodanfe: tipoDANFE,
        logomarca: logoMarca,
        tipodanfce: tipoDANFCE,
        modeloposprinter: modeloPosPrinter,
        portaposprinter: portaPosPrinter,
        paginadecodigo: paginaDeCodigo,
        paramsstring: paramsString,
        colunas,
        espacolinhas: espacoLinhas,
        linhasentrecupons: linhasEntreCupons,

        codassinante,
        codempresa,
      },
        {
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },

        });
      setshowform(false);
    } catch (error) {
      console.error('Erro ao salvar parametros:', error);
      setError('Erro ao tentar excluir os dados. Tente novamente.');
    } finally {
      setLoading(false);
    }
  }

  async function OpenParametro() {
    if (codempresa > 0) {
      setListaCategoria([]);

      fetchDataCategoria();
      fetchDataCategoriaPedidoCompra();
      fetchDataMoedaPedidoCompra();
      fetchDataCaixaPedidoCompra();

      try {
        setLoading(true);
        setError(null);
        const response = await api.get("v1/parametro", {
          params: {
            codempresa: codempresa,

          },
          headers: {
            Authorization: `Bearer ${accessKey}`,
          },
        });

        if (response.data.parametro.codparametro > 0) {
          setnovo(false);

          setCodParametro(response.data.parametro.codparametro);
          setUltNumPedido(response.data.parametro.ultnumpedido);
          setUltNumNota(response.data.parametro.ultnumnota);
          setUltNumMDFe(response.data.parametro.ultnummdfe);
          setCodContaVenda(response.data.parametro.codcontavenda);
          setCodContaPedidoCompra(response.data.parametro.codcontapedidocompra);
          setCodMoedaPedidoCompra(response.data.parametro.codmoedapedidocompra);
          setCodCaixaPedidoCompra(response.data.parametro.codcaixapedidocompra);
        } else {
          setnovo(true);

          setCodParametro(0);
          setUltNumPedido(0);
          setUltNumNota(0);
          setUltNumMDFe(0);
          setCodContaVenda(0);
          setCodContaPedidoCompra(0);
          setCodMoedaPedidoCompra(0);
          setCodCaixaPedidoCompra(0);
        }

        if (response.data.configuracao.id > 0) {
          setnovo(false);

          setCodConfiguracao(response.data.configuracao.id);
          //certificado
          setSSLLib(response.data.configuracao.ssllib);
          setCryptLib(response.data.configuracao.cryptlib);
          setHttpLib(response.data.configuracao.httplib);
          setXmlSignLib(response.data.configuracao.xmlsignlib);
          setArquivoCertificado(response.data.configuracao.certificadoa1);
          setSenha(response.data.configuracao.certificadosenha);
          //geral
          setAtualizarXML(response.data.configuracao.atualizarxml);
          setExibirErroSchema(response.data.configuracao.exibirerroschema);
          setFormatoAlerta(response.data.configuracao.formatoalerta);
          setFormaEmissao(response.data.configuracao.formaemissao);
          setModeloDF(response.data.configuracao.modelodf);
          setVersaoDF(response.data.configuracao.versaodf);
          setIdToken(response.data.configuracaoidtoken);
          setToken(response.data.configuracao.token);
          setRetirarAcentos(response.data.configuracao.retiraracentos);
          setSalvar(response.data.configuracao.salvargeral);
          setPathSalvar(response.data.configuracao.pathsalvar);
          setPathSchemas(response.data.configuracao.pathschemas);
          //webservice
          setUF(response.data.configuracao.webserviceuf);
          setAmbiente(response.data.configuracao.ambiente);
          setVisualizar(response.data.configuracao.visualizar);
          setSalvarSOAP(response.data.configuracao.salvarsoap);
          setAjustarAut(response.data.configuracao.ajustaraut);
          setAguardar(response.data.configuracao.aguardar);
          setTentativas(response.data.configuracao.tentativas);
          setIntervalo(response.data.configuracao.intervalo);
          setTimeOut(response.data.configuracao.timeout);
          setSSLType(response.data.configuracao.ssltype);
          setProxyHost(response.data.configuracao.proxyhost);
          setProxyPorta(response.data.configuracao.proxyporta);
          setProxyUser(response.data.configuracao.proxyuser);
          setProxySenha(response.data.configuracao.proxypass);
          //danfe
          setTipoDANFE(response.data.configuracao.tipodanfe);
          setLogoMarca(response.data.configuracao.logomarca);
          setTipoDANFCE(response.data.configuracao.tipodanfce);
          setModeloPosPrinter(response.data.configuracao.modeloposprinter);
          setPortaPosPrinter(response.data.configuracao.portaposprinter);
          setPaginaDeCodigo(response.data.configuracao.paginadecodigo);
          setParamsString(response.data.configuracao.paramsstring);
          setColunas(response.data.configuracao.colunas);
          setEspacoLinhas(response.data.configuracao.espacolinhas);
          setLinhasEntreCupons(response.data.configuracao.linhasentrecupons);
        } else {
          setnovo(true);

          setCodConfiguracao(0);
          //certificado
          setSSLLib(4);
          setCryptLib(3);
          setHttpLib(2);
          setXmlSignLib(4);
          setArquivoCertificado(null);
          setSenha('');
          //geral
          setAtualizarXML(1);
          setExibirErroSchema(1);
          setFormatoAlerta('TAG:%TAGNIVEL% ID:%ID%/%TAG%(%DESCRICAO%) - %MSG%.');
          setFormaEmissao(0);
          setModeloDF(0);
          setVersaoDF(3);
          setIdToken('');
          setToken('');
          setRetirarAcentos(1);
          setSalvar(1);
          setPathSalvar('C:\\Users\\Administrator\\Desktop\\NotaFiscal\\Logs');
          setPathSchemas('C:\\Users\\Administrator\\Desktop\\NotaFiscal\\Schemas');
          //webservice
          setUF(5);
          setAmbiente(0);
          setVisualizar(0);
          setSalvarSOAP(0);
          setAjustarAut('');
          setAguardar(0);
          setTentativas(5);
          setIntervalo(0);
          setTimeOut(5000);
          setSSLType(0);
          setProxyHost('');
          setProxyPorta('');
          setProxyUser('');
          setProxySenha('');
          //danfe
          setTipoDANFE(0);
          setLogoMarca('');
          setTipoDANFCE(0);
          setModeloPosPrinter(0);
          setPortaPosPrinter('');
          setPaginaDeCodigo(0);
          setParamsString('');
          setColunas(48);
          setEspacoLinhas(30);
          setLinhasEntreCupons(2);
        }

        setshowform(true);
      } catch (error) {
        console.error('Erro ao buscar dados:', error);
        setError('Erro ao carregar os dados. Tente novamente.');
      } finally {
        setLoading(false);
      }
    } else {
      alert('Selecione uma empresa');
    }
  }

  function handleFileChange(event) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = () => {
      // O resultado vem com o cabeçalho do tipo: data:application/x-pkcs12;base64,...
      // Vamos extrair só a parte do base64 puro
      const base64String = reader.result.split(',')[1];
      setArquivoCertificado(base64String);
    };

    reader.onerror = (error) => {
      console.error('Erro ao ler o arquivo:', error);
    };

    reader.readAsDataURL(file); // converte para base64
  }

  function handleFileLogoMarcaChange(event) {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();

    reader.onload = () => {
      // O resultado vem com o cabeçalho do tipo: data:application/x-pkcs12;base64,...
      // Vamos extrair só a parte do base64 puro
      const base64String = reader.result.split(',')[1];
      setLogoMarca(base64String);
    };

    reader.onerror = (error) => {
      console.error('Erro ao ler o arquivo:', error);
    };

    reader.readAsDataURL(file); // converte para base64
  }

  const fetchDataCategoria = async () => {
    try {

      setError(null);
      const response = await api.get("/v1/busca/categoriareceita", {
        params: {
          codassinante,
          codempresa // Usa o código recebido por parâmetro
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      });
      setListaCategoria(response.data);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      setError('Erro ao carregar os dados. Tente novamente.');
    } finally {
    }
  };

  const fetchDataCategoriaPedidoCompra = async () => {
    try {

      setError(null);
      const response = await api.get("/v1/busca/categoriadespesa", {
        params: {          
          codassinante,
          codempresa // Usa o código recebido por parâmetro
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      });
      setListaCategoriaPedidoCompra(response.data);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      setError('Erro ao carregar os dados. Tente novamente.');
    } finally {
    }
  };

  const fetchDataMoedaPedidoCompra = async () => {
    try {

      setError(null);
      const response = await api.get("/v1/busca/moeda", {
        params: {
          busca: '',
          codassinante,
          codempresa // Usa o código recebido por parâmetro
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      });
      setListaMoedaPedidoCompra(response.data);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      setError('Erro ao carregar os dados. Tente novamente.');
    } finally {
    }
  };

  const fetchDataCaixaPedidoCompra = async () => {
    try {

      setError(null);
      const response = await api.get("/v1/busca/caixa", {
        params: {
          busca: '',
          codassinante,
          codempresa // Usa o código recebido por parâmetro
        },
        headers: {
          Authorization: `Bearer ${accessKey}`,
        },
      });
      setListaCaixaPedidoCompra(response.data);
    } catch (error) {
      console.error('Erro ao buscar dados:', error);
      setError('Erro ao carregar os dados. Tente novamente.');
    } finally {
    }
  };

  return (
    <div className="app-container">
      <Sidebar onClick={OpenParametro} />

      <Modal
        isOpen={showform}
        onRequestClose={() => setshowform(false)}
        overlayClassName="modal-overlay"
        className="modal-content modal-xl"
      >
        <div className="container-fluid h-100">
          <div className="modal-header">
            {novo ? <h2>Novo Cadastro</h2> : <h2>Editando Cadastro</h2>}
            <button type="button" className="btn-close" onClick={() => setshowform(false)}></button>
          </div>

          <div className="modal-body">
            <ul className="nav nav-tabs" id="mainTab" role="tablist">
              <li className="nav-item">
                <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#parametros">Parâmetros</button>
              </li>
              <li className="nav-item">
                <button className="nav-link" data-bs-toggle="tab" data-bs-target="#fiscal">Configuração Fiscal</button>
              </li>
            </ul>

            <div className="tab-content mt-3">
              <div className="tab-pane fade show active" id="parametros">
                <div className="row">

                  <div className="col-md-4 mb-2">
                    <label htmlFor="UltNumPedido" className="form-label">Último Número do Pedido</label>
                    <input type="number" className="form-control" id="UltNumPedido" value={UltNumPedido} onChange={e => setUltNumPedido(Number(e.target.value))} />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label htmlFor="UltNumNota" className="form-label">Último Número da Nota</label>
                    <input type="number" className="form-control" id="UltNumNota" value={UltNumNota} onChange={e => setUltNumNota(Number(e.target.value))} />
                  </div>

                  <div className="col-md-4 mb-2">
                    <label htmlFor="UltNumMDFe" className="form-label">Último Número do MDF-e</label>
                    <input type="number" className="form-control" id="UltNumMDFe" value={UltNumMDFe} onChange={e => setUltNumMDFe(Number(e.target.value))} />
                  </div>    

                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <label htmlFor="codcontavenda" className="form-label">
                      Categoria de Venda
                    </label>
                    <select
                      id="codcontavenda"
                      className="form-select"
                      value={codcontavenda}
                      onChange={(e) => setCodContaVenda(e.target.value)}
                    >
                      <option value="0">Escolha a Categoria</option>
                      {listaCategoria.map(function (cat) {
                        return (
                          <option
                            key={cat.codcategoria}
                            value={cat.codcategoria}
                          >
                            {cat.descricao}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <label htmlFor="codcontapedidocompra" className="form-label">
                      Categoria de Pedido de Compra
                    </label>
                    <select
                      id="codcontapedidocompra"
                      className="form-select"
                      value={codcontapedidocompra}
                      onChange={(e) => setCodContaPedidoCompra(e.target.value)}
                    >
                      <option value="0">Escolha a Categoria</option>
                      {listaCategoriaPedidoCompra.map(function (cat) {
                        return (
                          <option
                            key={cat.codcategoria}
                            value={cat.codcategoria}
                          >
                            {cat.descricao}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <label htmlFor="codmoedapedidocompra" className="form-label">
                      Condição do Pedido de Compra
                    </label>
                    <select
                      id="codmoedapedidocompra"
                      className="form-select"
                      value={codmoedapedidocompra}
                      onChange={(e) => setCodMoedaPedidoCompra(e.target.value)}
                    >
                      <option value="0">Escolha a Condição</option>
                      {listaMoedaPedidoCompra.map(function (moe) {
                        return (
                          <option
                            key={moe.id}
                            value={moe.id}
                          >
                            {moe.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>

                  <div className="col-xl-6 col-lg-6 col-md-12 col-sm-12">
                    <label htmlFor="codcaixapedidocompra" className="form-label">
                      Caixa do Pedido de Compra
                    </label>
                    <select
                      id="codcaixapedidocompra"
                      className="form-select"
                      value={codcaixapedidocompra}
                      onChange={(e) => setCodCaixaPedidoCompra(e.target.value)}
                    >
                      <option value="0">Escolha o Caixa</option>
                      {listaCaixaPedidoCompra.map(function (cai) {
                        return (
                          <option
                            key={cai.id}
                            value={cai.id}
                          >
                            {cai.label}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                </div>
              </div>

              <div className="tab-pane fade" id="fiscal">
                <ul className="nav nav-tabs mt-3" id="fiscalTab" role="tablist">
                  <li className="nav-item">
                    <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#configuracao">Configuração</button>
                  </li>
                  <li className="nav-item">
                    <button className="nav-link" data-bs-toggle="tab" data-bs-target="#danfe">DANFE</button>
                  </li>
                </ul>

                <div className="tab-content mt-3">
                  <div className="tab-pane fade show active" id="configuracao">
                    <ul className="nav nav-tabs" id="subConfigTab" role="tablist">
                      <li className="nav-item">
                        <button className="nav-link active" data-bs-toggle="tab" data-bs-target="#webservice">Webservice</button>
                      </li>
                      <li className="nav-item">
                        <button className="nav-link" data-bs-toggle="tab" data-bs-target="#certificado">Certificado</button>
                      </li>
                      <li className="nav-item">
                        <button className="nav-link" data-bs-toggle="tab" data-bs-target="#geral">Geral</button>
                      </li>
                    </ul>

                    <div className="tab-content mt-3">
                      <div className="tab-pane fade show active" id="webservice">
                        <div className="row">
                          <div className="col-md-3 mb-2">
                            <label className="form-label">UF</label>
                            <select
                              className="form-select"
                              value={uf}
                              onChange={e => setUF(e.target.value)}
                            >
                              <option value="0">AC</option>
                              <option value="1">AL</option>
                              <option value="2">AP</option>
                              <option value="3">AM</option>
                              <option value="4">BA</option>
                              <option value="5">CE</option>
                              <option value="6">DF</option>
                              <option value="7">ES</option>
                              <option value="8">GO</option>
                              <option value="9">MA</option>
                              <option value="10">MT</option>
                              <option value="11">MS</option>
                              <option value="12">MG</option>
                              <option value="13">PA</option>
                              <option value="14">PB</option>
                              <option value="15">PR</option>
                              <option value="16">PE</option>
                              <option value="17">PI</option>
                              <option value="18">RJ</option>
                              <option value="19">RN</option>
                              <option value="20">RS</option>
                              <option value="21">RO</option>
                              <option value="22">RR</option>
                              <option value="23">SC</option>
                              <option value="24">SP</option>
                              <option value="25">SE</option>
                              <option value="26">TO</option>
                            </select>
                          </div>

                          <div className="col-md-3 mb-2">
                            <label className="form-label d-block">Ambiente</label>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="ambiente"
                                id="ambienteProducao"
                                value={0}
                                checked={ambiente === 0}
                                onChange={() => setAmbiente(0)}
                              />
                              <label className="form-check-label" htmlFor="ambienteProducao">
                                Produção
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                className="form-check-input"
                                type="radio"
                                name="ambiente"
                                id="ambienteHomologacao"
                                value={1}
                                checked={ambiente === 1}
                                onChange={() => setAmbiente(1)}
                              />
                              <label className="form-check-label" htmlFor="ambienteHomologacao">
                                Homologação
                              </label>
                            </div>
                          </div>

                          <div className="col-md-3 mb-2">
                            <div className="form-check mt-4">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="visualizarCheckbox"
                                checked={visualizar === 1}
                                onChange={e => setVisualizar(e.target.checked ? 1 : 0)}
                              />
                              <label className="form-check-label" htmlFor="visualizarCheckbox">
                                Visualizar
                              </label>
                            </div>
                          </div>

                          <div className="col-md-3 mb-2">
                            <div className="form-check mt-4">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="salvarSOAPCheckbox"
                                checked={salvarSOAP === 1}
                                onChange={e => setSalvarSOAP(e.target.checked ? 1 : 0)}
                              />
                              <label className="form-check-label" htmlFor="salvarSOAPCheckbox">
                                Salvar SOAP
                              </label>
                            </div>
                          </div>

                          <div className="col-md-3 mb-2">
                            <div className="form-check mt-4">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="ajustarAutCheckbox"
                                checked={ajustarAut === 1}
                                onChange={e => setAjustarAut(e.target.checked ? 1 : 0)}
                              />
                              <label className="form-check-label" htmlFor="ajustarAutCheckbox">
                                Ajustar Automaticamente prop. "Aguardar"
                              </label>
                            </div>
                          </div>

                          <div className="col-md-2 mb-2">
                            <label className="form-label">Aguardar</label>
                            <input type="text" className="form-control" value={aguardar} onChange={e => setAguardar(e.target.value)} />
                          </div>

                          <div className="col-md-2 mb-2">
                            <label className="form-label">Tentativas</label>
                            <input type="text" className="form-control" value={tentativas} onChange={e => setTentativas(e.target.value)} />
                          </div>

                          <div className="col-md-2 mb-2">
                            <label className="form-label">Intervalo</label>
                            <input type="text" className="form-control" value={intervalo} onChange={e => setIntervalo(e.target.value)} />
                          </div>

                          <div className="col-md-2 mb-2">
                            <label className="form-label">Timeout</label>
                            <input type="number" className="form-control" value={timeOut} onChange={e => setTimeOut(Number(e.target.value))} />
                          </div>

                          <div className="col-md-3 mb-2">
                            <label className="form-label">SSL Type</label>
                            <select
                              className="form-select"
                              value={sslType}
                              onChange={e => setSSLType(Number(e.target.value))}
                            >
                              <option value={0}>LT_all</option>
                              <option value={1}>LT_SSLv2</option>
                              <option value={2}>LT_SSLv3</option>
                              <option value={3}>LT_TLSv1</option>
                              <option value={4}>LT_TLSv1_1</option>
                              <option value={5}>LT_TLSv1_2</option>
                              <option value={6}>LT_TLSv1_3</option>
                              <option value={7}>LT_SSHv2</option>
                            </select>
                          </div>

                          <div className="col-md-3 mb-2">
                            <label className="form-label">Proxy Host</label>
                            <input type="text" className="form-control" value={proxyHost} onChange={e => setProxyHost(e.target.value)} />
                          </div>

                          <div className="col-md-2 mb-2">
                            <label className="form-label">Proxy Porta</label>
                            <input type="text" className="form-control" value={proxyPorta} onChange={e => setProxyPorta(e.target.value)} />
                          </div>

                          <div className="col-md-3 mb-2">
                            <label className="form-label">Proxy User</label>
                            <input type="text" className="form-control" value={proxyUser} onChange={e => setProxyUser(e.target.value)} />
                          </div>

                          <div className="col-md-3 mb-2">
                            <label className="form-label">Proxy Senha</label>
                            <input type="password" className="form-control" value={proxySenha} onChange={e => setProxySenha(e.target.value)} />
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="certificado">
                        <div className="row">

                          <div className="col-md-6 mb-2">
                            <label className="form-label">SSL Lib</label>
                            <select
                              className="form-select"
                              value={sSLLib}
                              onChange={e => setSSLLib(Number(e.target.value))}
                            >
                              <option value={0}>libNone</option>
                              <option value={1}>libOpenSSL</option>
                              <option value={2}>libCapicom</option>
                              <option value={3}>libCapicomDelphiSoap</option>
                              <option value={4}>libWinCrypt</option>
                              <option value={5}>libCustom</option>
                            </select>
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">Crypt Lib</label>
                            <select
                              className="form-select"
                              value={cryptLib}
                              onChange={e => setCryptLib(Number(e.target.value))}
                            >
                              <option value={0}>cryNone</option>
                              <option value={1}>cryOpenSSL</option>
                              <option value={2}>cryCapicom</option>
                              <option value={3}>cryWinCrypt</option>
                            </select>
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">HTTP Lib</label>
                            <select
                              className="form-select"
                              value={httpLib}
                              onChange={e => setHttpLib(Number(e.target.value))}
                            >
                              <option value={0}>httpNone</option>
                              <option value={1}>httpWinINet</option>
                              <option value={2}>httpWinHttp</option>
                              <option value={3}>httpOpenSSL</option>
                              <option value={4}>httpIndy</option>
                            </select>
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">XML Sign Lib</label>
                            <select
                              className="form-select"
                              value={xmlSignLib}
                              onChange={e => setXmlSignLib(Number(e.target.value))}
                            >
                              <option value={0}>xsNone</option>
                              <option value={1}>xsXmlSec</option>
                              <option value={2}>xsMsXml</option>
                              <option value={3}>xsMsXmlCapicom</option>
                              <option value={4}>xsLibXml2</option>
                            </select>
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">Arquivo do Certificado</label>
                            <input type="file" className="form-control" onChange={handleFileChange} />
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">Senha</label>
                            <input type="password" className="form-control" value={senha} onChange={e => setSenha(e.target.value)} />
                          </div>
                        </div>
                      </div>
                      <div className="tab-pane fade" id="geral">
                        <div className="row">
                          <div className="col-md-3 mb-2">
                            <div className="form-check mt-4">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={atualizarXML === 1}
                                onChange={e => setAtualizarXML(e.target.checked ? 1 : 0)}
                                id="atualizarXML"
                              />
                              <label className="form-check-label" htmlFor="atualizarXML">
                                Atualizar XML
                              </label>
                            </div>
                          </div>

                          <div className="col-md-3 mb-2">
                            <div className="form-check mt-4">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                checked={exibirErroSchema === 1}
                                onChange={e => setExibirErroSchema(e.target.checked ? 1 : 0)}
                                id="exibirErroSchema"
                              />
                              <label className="form-check-label" htmlFor="exibirErroSchema">
                                Exibir Erro Schema
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">Formato Alerta</label>
                            <input type="text" className="form-control" value={formatoAlerta} onChange={e => setFormatoAlerta(e.target.value)} />
                          </div>
                          <div className="col-md-6 mb-2">
                            <label className="form-label">Forma de Emissão</label>
                            <select
                              className="form-select"
                              value={formaEmissao}
                              onChange={e => setFormaEmissao(Number(e.target.value))}
                            >
                              <option value={0}>teNormal</option>
                              <option value={1}>teContingencia</option>
                              <option value={2}>teSCAN</option>
                              <option value={3}>teDPEC</option>
                              <option value={4}>teFSDA</option>
                              <option value={5}>teSVCAN</option>
                              <option value={6}>teSVCRS</option>
                              <option value={7}>teSVCSP</option>
                              <option value={8}>teOffLine</option>
                            </select>
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">Modelo DF</label>
                            <select
                              className="form-select"
                              value={modeloDF}
                              onChange={e => setModeloDF(Number(e.target.value))}
                            >
                              <option value={0}>moNFe</option>
                              <option value={1}>moNFCe</option>
                            </select>
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">Versão DF</label>
                            <select
                              className="form-select"
                              value={versaoDF}
                              onChange={e => setVersaoDF(Number(e.target.value))}
                            >
                              <option value={0}>ve200</option>
                              <option value={1}>ve300</option>
                              <option value={2}>ve310</option>
                              <option value={3}>ve400</option>
                            </select>
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">ID Token</label>
                            <input type="text" className="form-control" value={idToken} onChange={e => setIdToken(e.target.value)} />
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">Token</label>
                            <input type="text" className="form-control" value={token} onChange={e => setToken(e.target.value)} />
                          </div>

                          <div className="col-md-3 mb-2">
                            <div className="form-check mt-4">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="retirarAcentos"
                                checked={retirarAcentos === 1}
                                onChange={e => setRetirarAcentos(e.target.checked ? 1 : 0)}
                              />
                              <label className="form-check-label" htmlFor="retirarAcentos">
                                Retirar Acentos dos XMLs enviados
                              </label>
                            </div>
                          </div>

                          <div className="col-md-3 mb-2">
                            <div className="form-check mt-4">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="salvar"
                                checked={salvar === 1}
                                onChange={e => setSalvar(e.target.checked ? 1 : 0)}
                              />
                              <label className="form-check-label" htmlFor="salvar">
                                Salvar Arquivos de Envio e Resposta
                              </label>
                            </div>
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">Path Salvar</label>
                            <input disabled type="text" className="form-control" value={pathSalvar} onChange={e => setPathSalvar(e.target.value)} />
                          </div>

                          <div className="col-md-6 mb-2">
                            <label className="form-label">Path Schemas</label>
                            <input disabled type="text" className="form-control" value={pathSchemas} onChange={e => setPathSchemas(e.target.value)} />
                          </div>

                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="tab-pane fade" id="danfe">
                    <div className="row">
                      <div className="col-md-6 mb-2">
                        <label className="form-label d-block">Tipo DANFE</label>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tipoDANFE"
                            id="danfeRetrato"
                            value={0}
                            checked={tipoDANFE === 0}
                            onChange={() => setTipoDANFE(0)}
                          />
                          <label className="form-check-label" htmlFor="danfeRetrato">
                            Retrato
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tipoDANFE"
                            id="danfePaisagem"
                            value={1}
                            checked={tipoDANFE === 1}
                            onChange={() => setTipoDANFE(1)}
                          />
                          <label className="form-check-label" htmlFor="danfePaisagem">
                            Paisagem
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6 mb-2">
                        <label className="form-label">Logo Marca</label>
                        <input
                          type="file"
                          className="form-control"
                          accept="image/*"
                          onChange={handleFileLogoMarcaChange}
                        />
                      </div>

                      <div className="col-md-6 mb-2">
                        <label className="form-label d-block">Tipo DANFCE</label>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tipoDANFCE"
                            id="danfceFortes"
                            value={0}
                            checked={tipoDANFCE === 0}
                            onChange={() => setTipoDANFCE(0)}
                          />
                          <label className="form-check-label" htmlFor="danfceFortes">
                            Fortes
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tipoDANFCE"
                            id="danfceEscPos"
                            value={1}
                            checked={tipoDANFCE === 1}
                            onChange={() => setTipoDANFCE(1)}
                          />
                          <label className="form-check-label" htmlFor="danfceEscPos">
                            EscPos
                          </label>
                        </div>
                        <div className="form-check form-check-inline">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="tipoDANFCE"
                            id="danfceA4"
                            value={2}
                            checked={tipoDANFCE === 2}
                            onChange={() => setTipoDANFCE(2)}
                          />
                          <label className="form-check-label" htmlFor="danfceA4">
                            A4
                          </label>
                        </div>
                      </div>

                      <div className="col-md-6 mb-2">
                        <label className="form-label">Modelo POS Printer</label>
                        <select
                          className="form-select"
                          value={modeloPosPrinter}
                          onChange={e => setModeloPosPrinter(Number(e.target.value))}
                        >
                          <option value={0}>ppTexto</option>
                          <option value={1}>ppEscPosEpson</option>
                          <option value={2}>ppEscBematech</option>
                          <option value={3}>ppEscDaruma</option>
                          <option value={4}>ppEscVox</option>
                          <option value={5}>ppEscDiebold</option>
                          <option value={6}>ppEscEpsonP2</option>
                          <option value={7}>ppCustomPos</option>
                          <option value={8}>ppCustomPos</option>
                          <option value={9}>ppEscPosStar</option>
                        </select>
                      </div>

                      <div className="col-md-6 mb-2">
                        <label className="form-label">Porta POS Printer</label>
                        <input type="text" className="form-control" value={portaPosPrinter} onChange={e => setPortaPosPrinter(e.target.value)} />
                      </div>

                      <div className="col-md-6 mb-2">
                        <label className="form-label">Página de Código</label>
                        <select
                          className="form-select"
                          value={paginaDeCodigo}
                          onChange={e => setPaginaDeCodigo(Number(e.target.value))}
                        >
                          <option value={0}>pcNone</option>
                          <option value={1}>pc437</option>
                          <option value={2}>pc850</option>
                          <option value={3}>pc852</option>
                          <option value={4}>pc860</option>
                          <option value={5}>pcUTF8</option>
                          <option value={6}>pc1252</option>
                        </select>
                      </div>

                      <div className="col-md-6 mb-2">
                        <label className="form-label">Parâmetros String</label>
                        <input type="text" className="form-control" value={paramsString} onChange={e => setParamsString(e.target.value)} />
                      </div>

                      <div className="col-md-2 mb-2">
                        <label className="form-label">Colunas</label>
                        <input type="number" className="form-control" value={colunas} onChange={e => setColunas(Number(e.target.value))} />
                      </div>

                      <div className="col-md-2 mb-2">
                        <label className="form-label">Espaços Linhas</label>
                        <input type="number" className="form-control" value={espacoLinhas} onChange={e => setEspacoLinhas(Number(e.target.value))} />
                      </div>

                      <div className="col-md-2 mb-2">
                        <label className="form-label">Linhas Pular</label>
                        <input type="number" className="form-control" value={linhasEntreCupons} onChange={e => setLinhasEntreCupons(Number(e.target.value))} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-danger" onClick={() => setshowform(false)}>Cancelar</button>
            <button type="button" className="btn btn-success" onClick={Salvar}>Salvar</button>
          </div>
        </div>
      </Modal>


      <div className="content-container">
        <div className="container-fluid">

          {loading ? (
            <div className="text-center py-4">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Carregando...</span>
              </div>
            </div>
          ) : null}

        </div>
      </div>
    </div>
  );
}

export default Principal;